import { inArray } from '../../util/jquery';
export default class Snapshot {
    constructor(options) {
        this.securityManager = options.securityManager;
        this.apiManager = options.apiManager;
        this._cacheMap = new Map();
    }

    /**
     * Get snapshot data.
     * @param params - some parameters collection, you can use security.
     * @param params.securities - A valid security could be performance id, security id, exch:symbol, realtime id.
     * @param params.fields - An array of Data points.
     * @returns {Promise}
     */
    async snapshot(params) {
        if (
            !params.securities ||
            !params.securities.length ||
            !params.fields ||
            !params.fields.length
        ) {
            throw new Error('Missing required parameters securities or fields');
        }
        const securities = await this.securityManager.create(params.securities);
        if (securities.length > 0) {
            const tickers = securities.map(s => s.securityId);
            const queryTickers = tickers.filter(t => !this._cacheMap.has(t));
            let res = [];
            if (queryTickers.length) {
                res = await this.apiManager.snapshot({
                    tickers: queryTickers.join(','),
                    fields: params.fields.join(',')
                });
            }
            return this._transform(params, res);
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.securities
            );
        }
    }
    _transform(param, data = []) {
        return param.securities.map(s => {
            const item = {
                security: s,
                snapshot: []
            };
            const securities = this.securityManager.getSecurities([s]);
            if (securities.length) {
                const secId = securities[0].securityId;
                if (this._cacheMap.has(secId)) {
                    item.snapshot = this._cacheMap.get(secId);
                } else {
                    const idx = inArray(data, d => d.ticker === secId);
                    if (idx > -1) {
                        item.snapshot = data[idx].snapshot;
                    }
                    this._cacheMap.set(secId, item.snapshot);
                }
            }
            return item;
        });
    }
}
